import { connect } from 'react-redux';

const mapStateToProps = state => ({
  urls: state.mainreducer.urls,
  selectedLocations: state.mainreducer.selectedLocations,
  formAuthToken: state.mainreducer.formAuthToken,
  formPostUrl: state.mainreducer.signupFormUrl
});

export default AboutUsRightPart => connect(mapStateToProps, null)(AboutUsRightPart);
